import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const MailFillIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M0.0619802 2.4423C0.314654 1.32907 1.31025 0.498047 2.49994 0.498047H17.4996C18.6892 0.498047 19.6848 1.32907 19.9375 2.4423L9.99974 8.51538L0.0619802 2.4423ZM0 3.86932V12.7485L7.25381 8.3022L0 3.86932ZM8.45153 9.03414L0.239833 14.0676C0.640739 14.913 1.50206 15.4977 2.49994 15.4977H17.4996C18.4974 15.4977 19.3587 14.913 19.7597 14.0676L11.548 9.03414L9.99974 9.98027L8.45153 9.03414ZM12.7457 8.3022L19.9995 12.7485V3.86932L12.7457 8.3022Z",
    fill: color
  }));
};
export default MailFillIcon;